import { zones as zonesService } from 'services/zones';
import { Content, Zone } from './zones-row.styled';

export const ZonesRow = () => {
  const zones = zonesService.getZones();

  const zonesList = zones.map((item) => {
    const id = item.zone_id;
    const title = id;
    const color = item.background_color;
    return (
      <Zone key={id} color={color}>
        {title}
      </Zone>
    );
  });

  return <Content>{zonesList}</Content>;
};
